<template>
  <div class="columns is-multiline">
    <div
      class="column is-one-quarter is-gapless has-text-centered"
      v-for="article in articles.slice(0, limit)"
      :key="article.slug"
    >
      <router-link
        :to="{name: 'article', params: {slug: article.slug }}"
        class="article-title-link"
      >
        <div>
          <figure class="image has-image-centered is-128x128">
            <picture>
              <source type="image/webp" :srcset="article.image_src_webp" />
              <img :src="article.image_src_jpg" :alt="article.title" />
            </picture>
          </figure>
          <span class="has-text-weight-bold">{{ article.title }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import articles from "../articles.json";

let revArticles = articles.reverse().slice();

export default {
  name: "ArticlesTeaser",
  data() {
    return {
      articles: revArticles,
    };
  },
  props: ["limit"],
};
</script>

<style>
.has-image-centered {
  margin-left: auto;
  margin-right: auto;
}
.article-title-link {
  color: #f03a5f;
}
.article-title-link:hover {
  color: #a0112e;
}
</style>
